import React, { useState } from 'react'

import { useDispatch } from "react-redux";
import { addSurveyQuestion, removeSurveyQuestion, setQuestionAnswerList } from '../../system/redux/reducers/surveyReducer';
import { apiHostUrl, getSubQuestion } from '../../../constants/constants';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Form } from 'react-bootstrap';
import TextLabel from './TextLabel';
import SurveyRadioCheck from './SurveyRadioCheck';
import SurveyHidden from './SurveyHidden';
import SurveyTextArea from './SurveyTextArea';
import SurveyCheckBox from './SurveyCheckBox';
import SurveyStarRating from './SurveyStarRating';
import SurveyDropDown from './SurveyDropDown';
import SurveyMultiSelectDropdown from './SurveyMultiSelectDropdown';
import SurveyDynamicDropDown from './SurveyDynamicDropDown';
import SurveyDynamicCheckBox from './SurveyDynamicCheckBox';
import SurveyDynamicRadioButton from './SurveyDynamicRadioButton';
import SurveyDynamicMultipleDropDown from './SurveyDynamicMultipleDropDown';

export default function SurveyQuestionnaires(props) {
  const dispatch = useDispatch();
  const [questions, setQuestions] = useState(props.questions);
  debugger;
  const { csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
  const [headers, setHeaders] = useState({
    'X-Csrf-Token': csrfToken,
    'Content-Type': 'application/json'
  });
  const[mode,setMode] = useState(props?.mode)
  const [answerMapping, setAnswerMapping] = useState(props?.answerList);
  const [correct, setC] = useState(props?.correct);

  const getSubQuestionURL = apiHostUrl + getSubQuestion;

  const addRemoveSubQuestions = (selectedOptionId, subQuestions, unSelectedOptions) => {
    
    debugger;
    if (unSelectedOptions?.length > 0 && subQuestions?.length > 0) {
        var removableQuestions = subQuestions.filter(question => unSelectedOptions.includes(question.parentQuestionOptionId));
        if (removableQuestions?.length > 0) {
            removableQuestions.forEach(removableSurveyQuestion => {
                var removableQuestionPayload = {
                  id: removableSurveyQuestion.id
                };
                
                dispatch(setQuestionAnswerList(removableQuestionPayload));
                dispatch(removeSurveyQuestion(removableSurveyQuestion));
                subQuestions.splice(subQuestions.indexOf(removableSurveyQuestion), 1);
            });
        }
    }

    axios.get(`${getSubQuestionURL}/${selectedOptionId}`,
            {},
            { withCredentials: "true" },
            { headers: headers }
        )
        .then((response) => {
            // Handle success
            console.log("Response:", response);
            //setQuestion(response.data);
            if (response?.data?.length > 0) {
                response.data.forEach(newSurveyQuestion => {
                    //props.surveyQuestionList.push(q);
                    subQuestions.push(newSurveyQuestion);
                    dispatch(addSurveyQuestion(newSurveyQuestion));
                });
            }
        })
        .catch((error) => {
            // Handle error
            console.error("Error:", error);
        });
  }

  return (
    <>
      
      {questions?.map(question => (
        <div key={question.id} className='mb-4'>

          {/* Displaying the question text here excluded hidden type */}
          {question.questionType !== 101 &&
            <Form.Label className='fs-6 fw-medium'>
              <TextLabel title={question.name} /> 
            </Form.Label>}

          <input type='hidden' id={"question-id-" + question.id} class={"question-id-" + question.id} name={"questionList[" + question.questionSequenceNo + "].id"} value={question.id} />

          <div className='clearfix'></div>

          {(() => {
            switch (question.questionType) {
              case 100:
                return <SurveyRadioCheck question={question} mode={mode} answerMapping={mode===1 ? answerMapping.filter((e)=>e.questionId===question.id):null} correct={mode===1?correct.filter((e)=>e.questionid===question.id):null}/>
              case 101:
                return <SurveyHidden question={question} />
              case 102:
                return <SurveyTextArea question={question} />
              case 103:
                return <SurveyCheckBox question={question} />;
              case 104:
                return <SurveyStarRating question={question} addRemoveSubQuestions={addRemoveSubQuestions} />
              case 105:
                return <SurveyDropDown question={question} />
              case 106:
                return <SurveyMultiSelectDropdown question={question} />;
              case 107:
                return <SurveyDynamicDropDown question={question} />
              case 108:
                return <SurveyDynamicCheckBox question={question} />;
              case 109:
                return <SurveyDynamicRadioButton question={question} />
              case 110:
                return <SurveyDynamicMultipleDropDown question={question} />;
              default:
            }
          })()}
        </div>
      ))}

    </>
  )
}
